import { create } from 'zustand';
import type { Product } from '@/types/Product.types';

type ToastAction =
  // For opening the slaylist selector
  | { type: 'change'; productId: number; productImage?: string }
  | { type: 'undo'; product: Product; index: number; slaylistId: number };

// The button now contains the text and the structured action object
interface ToastButton {
  text: string;
  action: ToastAction;
}

export interface Toast {
  id: number;
  message: string;
  button?: ToastButton;
}

export interface ToastStore {
  toasts: Toast[];
  showToast: (message: string, button?: ToastButton) => number;
  removeToast: (id: number) => void;
  clearAllToasts: () => void;
}

const useToastStore = create<ToastStore>((set) => ({
  toasts: [],

  showToast: (message: string, button?: ToastButton): number => {
    const id = Date.now() + Math.random();
    const newToast: Toast = {
      id,
      message,
      button,
    };

    // Replace any existing toast with the new one
    set({ toasts: [newToast] });

    return id;
  },

  removeToast: (id: number) =>
    set((state) => ({
      toasts: state.toasts.filter((toast) => toast.id !== id),
    })),

  clearAllToasts: () => set({ toasts: [] }),
}));

export default useToastStore;
